"use client";

import { useCallback } from "react";
import SwedenFlag from "~/components/icons/logo-sweden";
import UKFlag from "~/components/icons/loog-united-kingdom";
import { useTranslation } from "~/components/translate";
import { Button } from "~/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { cn } from "~/lib/utils";

// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: "Svenska",
    value: "sv",
    icon: <SwedenFlag size="28px" />,
  },
  {
    label: "English",
    value: "en",
    icon: <UKFlag size="28px" />,
  },
];

export default function LanguagePopover() {
  const { setLocale, lang, dictionary } = useTranslation();

  const currentLang = allLangs.find((langObj) => langObj.value === lang);

  const handleChangeLang = useCallback(
    (langValue: (typeof allLangs)[number]["value"]) => {
      setLocale(langValue as AppLocale);
    },
    [setLocale],
  );

  if (!currentLang) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="text-muted-foreground rounded-full"
          aria-label={dictionary["Byt språk"]}
        >
          <span className="sr-only">{dictionary["Byt språk"]}</span>
          {currentLang.icon}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {allLangs.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => handleChangeLang(option.value)}
            className={cn("gap-2", {
              "bg-muted ": option.value === currentLang.value,
            })}
          >
            {option.icon}
            <span>{option.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
